import React, { useState, useRef, useEffect } from "react";
import { Card, PageHeader } from "@/components/ui";
import { Play, Trophy, FileCheck, Users } from "lucide-react";

const VIDEOS = [
  { key: "submission", src: "/media/win-submission.mp4", icon: FileCheck, label: "How to Win the Submission",
    tag: "THE SUBMISSION", desc: "Lead with credibility and a live demo, send the full submittal packet, make founder accountability your edge, and remove the risk in writing." },
  { key: "interaction", src: "/media/win-interaction.mp4", icon: Users, label: "Winning Every Interaction",
    tag: "THE MEETINGS", desc: "How to carry the intro call, demo, security review, and BAFO — and exactly what to share vs. keep." },
  { key: "edge", src: "/media/win-edge.mp4", icon: Trophy, label: "Your Winning Edge",
    tag: "THE MINDSET", desc: "Why a new, AI-native platform backed by 26 years of Eagle Healthcare experience beats the biggest vendor." },
];

export default function WinningPlaybook() {
  const [active, setActive] = useState("submission");
  const videoRef = useRef(null);
  const current = VIDEOS.find((v) => v.key === active);
  useEffect(() => { if (videoRef.current) videoRef.current.load(); }, [active]);

  return (
    <div className="vc-fade-up" data-testid="winning-playbook">
      <PageHeader title="Winning Playbook — Video Coaching" subtitle="Short internal coaching clips on how to win the Trillium submission and every interaction. For your eyes only — not shareable." />

      <div className="grid lg:grid-cols-12 gap-6">
        <div className="lg:col-span-8">
          <Card className="p-2 overflow-hidden">
            <video ref={videoRef} key={active} controls playsInline preload="metadata" className="w-full rounded-lg bg-black aspect-video" data-testid="winning-video">
              <source src={current.src} type="video/mp4" />
            </video>
          </Card>
          <div className="mt-3 flex items-start gap-3">
            <span className="mt-0.5 text-[10px] font-bold tracking-[0.2em] text-brand-700">{current.tag}</span>
            <p className="text-sm text-muted-foreground">{current.desc}</p>
          </div>
        </div>

        <div className="lg:col-span-4 flex flex-col gap-3">
          {VIDEOS.map((v) => (
            <button key={v.key} onClick={() => setActive(v.key)} data-testid={`winning-tab-${v.key}`}
              className={`text-left rounded-xl border p-4 transition-colors ${active === v.key ? "border-brand-500 bg-brand-50" : "border-border bg-card hover:bg-accent"}`}>
              <div className="flex items-center gap-3">
                <span className={`h-10 w-10 shrink-0 rounded-lg flex items-center justify-center ${active === v.key ? "bg-brand-600 text-white" : "bg-brand-50 text-brand-700"}`}>
                  {active === v.key ? <Play className="h-4 w-4" /> : <v.icon className="h-4 w-4" />}
                </span>
                <div>
                  <p className="font-display font-semibold text-sm text-foreground">{v.label}</p>
                  <p className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground mt-0.5">{v.tag}</p>
                </div>
              </div>
            </button>
          ))}
          <Card className="p-4 bg-brand-950 text-white border-0 mt-1">
            <p className="text-sm text-brand-100"><strong className="text-white">Tip:</strong> Watch these before any Trillium touchpoint, then grab the matching Meeting Prep cheat-sheet in Go-To-Market.</p>
          </Card>
        </div>
      </div>
    </div>
  );
}
